
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllOffboardingReport  = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/offboarding/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);
export const fetchAllOffboardingReportCount  = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/offboarding/count/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);
export const fetchAllOffboardingReportCountMonthly  = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/offboarding/count/monthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Maintenance Report');
        }
    }
);